import React, { createContext, createRef } from 'react';
import { ChartItem, DayProps } from '../types';

type GanttChartContextProps = {
  items: ChartItem[];
  chartStartDate?: Date | undefined;
  chartEndDate?: Date | undefined;
  setCurrentStrip?: (node: HTMLDivElement | null) => void;
  currentStripRef?: React.MutableRefObject<HTMLDivElement | null>;
  setCurrentItem?: (item: ChartItem | null) => void;
  currentItem?: React.MutableRefObject<ChartItem | null>;
  resizingSide?: React.MutableRefObject<'left' | 'right' | undefined>;
  setResizingSide?: (side: 'left' | 'right' | undefined) => void;
  resizeStartOffset?: React.MutableRefObject<number>;
  setResizeStartOffset?: (side: number) => void;
  datesFullRange?: DayProps[];
  datesRangeByMonths?: { [key: string]: DayProps[] };
  resizingLayerRef?: React.MutableRefObject<HTMLDivElement | null>;
  collapsibleStates: { [key: string]: boolean };
  handleItemsCollapse?: (parentId: string, isCollapsed?: boolean) => void;
  dateTrackerLabelRef?: React.MutableRefObject<HTMLDivElement | null>;
  sidebarRef?: React.MutableRefObject<HTMLDivElement | null>;
  stripIndicatorsListRef?: React.MutableRefObject<(HTMLDivElement | null)[]>;
  chartContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  todayIndex?: number;
  extendStartRange?: (startOffset: number) => Promise<{ daysCount: number }> | undefined;
  extendEndRange?: (endOffset: number) => void;
  primaryColor?: string;
  secondaryColor?: string;
};

export const GanttChartContext = createContext<GanttChartContextProps>({
  items: [],
  collapsibleStates: {},
  chartContainerRef: createRef<HTMLDivElement>(),
});
